import React from "react";

import { Col, OverlayTrigger, Stack, Tooltip } from "react-bootstrap";

import classNames from "classnames";

import { DetailCell } from "@components/resale_submission/DetailCell";

import styles from "./DetailsRow.module.scss";

interface Detail {
  title: string;
  value: string | React.ReactNode;
  isBadge?: boolean;
  isClickable?: boolean;
  onClick?: () => void;
}

interface DetailsRowProps {
  details: Detail[];
  style?: React.CSSProperties;
  className?: string;
}

const DetailsRow: React.FC<DetailsRowProps> = ({ details, style, className }) => {
  return (
    <Stack
      gap={4}
      className={classNames(
        styles["accordion-content-container"],
        `${className} d-flex justify-content-center align-items-center align-self-stretch flex-row`,
      )}
      style={{ ...style }}
    >
      {details.map((detail) => (
        <Col
          key={`${detail.title}`}
          style={{
            flex: 1, // Make all columns take equal width
            minWidth: 0, // Allow truncation
          }}
          onClick={detail.isClickable && detail.onClick ? detail.onClick : undefined}
        >
          <div
            className={classNames(styles["cell-container"], {
              "w-100": !detail.isBadge,
              [styles["clickable"]]: detail.isClickable,
            })}
          >
            {detail.isBadge ? (
              <span>{detail.value}</span>
            ) : (
              <OverlayTrigger placement="left" overlay={<Tooltip>{detail.value || "undefined"}</Tooltip>}>
                <div
                  className="w-100 text-truncate"
                  style={{
                    minWidth: 0,
                  }}
                >
                  <DetailCell labelClassName="text-truncate" title={detail.title} value={detail.value} />
                </div>
              </OverlayTrigger>
            )}
          </div>
        </Col>
      ))}
    </Stack>
  );
};

export default DetailsRow;
